module.exports = __webpack_public_path__ + "img/13_41.4d7cd6e5.png";